import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { BomPackingItemsDto } from '.';
import { BomSODto } from './all-bom-so.dto';


export class GetAllBomDataResponseModel extends GlobalResponseObject {
    data?: BomPackingItemsDto[];

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data /BomPackingItemsDto[]
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: BomPackingItemsDto[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}

 